import sysEnv from '@/env/envs'

import axios from 'axios'

import store from '@/store'

import router from '@/router'

export const httpRequestMethods = Object.freeze({
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put',
  PATCH: 'patch'
})

class APIError extends Error {
  constructor (type, httpCode, message) {
    super(message)
    this.name = this.constructor.name
    this.httpCode = httpCode
    this.type = type
    this.unprocessed = true
  }
}

const ErrorType = Object.freeze({
  // 请求未发出就抛出异常 网络错误
  'NETWORK': 'NETWORK',
  // 400 客户端错误 地址不存在
  'CLINENT': 'CLINENT',
  // token失效
  'UNAUTHORIZED': 'UNAUTHORIZED',
  // 没有权限
  'NOPERMISSION': 'NOPERMISSION',
  // 自定义错误，后台捕获的错误
  'CUSTOMIZE': 'CUSTOMIZE',
  // 服务器异常错误
  'SERVER': 'SERVER',
  // 未知错误
  'UNKNOWN': 'UNKNOWN'
})

let testAdr = null

// 需要连接局域网测试的时候 修改下面地址
// testAdr = 'http://192.168.124.5:8780'

const apiBaseURL = process.env.NODE_ENV === 'production' ? sysEnv.apiAdr : (testAdr || sysEnv.apiAdr)

const dealRdata = function (data) {
  try {
    if (!sysEnv.isZsyNw && typeof data === 'string') {
      data = data.replace(/中石油/g, 'zsy')
    }
    if (data && typeof data === 'string') {
      data = JSON.parse(data)
    }
  } catch (error) {
    console.log(error)
  }
  return data
}

export const axiosCommonConfig = Object.freeze({
  timeout: 10000000,
  baseURL: apiBaseURL,
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Methods': '*'
  },
  transformResponse: [function (data) {
    return dealRdata(data)
  }]
})

export const axiosCommonConfigMap = Object.freeze({
  timeout: 10000000,
  baseURL: apiBaseURL + '/arab',
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Methods': '*'
  },
  transformResponse: [function (data) {
    return dealRdata(data)
  }]
})

export const axiosCommonConfigCar = Object.freeze({
  timeout: 10000000,
  baseURL: 'http://192.168.210.224:8785',
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Methods': '*'
  },
  transformResponse: [function (data) {
    return dealRdata(data)
  }]
})

export const axiosCommonConfigUpload = Object.freeze({
  timeout: 10000000,
  baseURL: apiBaseURL + '/arab',
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Methods': '*'
  },
  transformResponse: [function (data) {
    return dealRdata(data)
  }]
})

export const axiosInstance = axios.create(axiosCommonConfig)

export const axiosInstanceMap = axios.create(axiosCommonConfigMap)

export const axiosInstanceCar = axios.create(axiosCommonConfigCar)

export const axiosInstanceUpload = axios.create(axiosCommonConfigUpload)

// http request 拦截器
axiosInstance.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(new APIError(ErrorType.NETWORK, null, error.message))
})

// http response 拦截器
axiosInstance.interceptors.response.use(function (response) {
  return response.data || response
},
function (error) {
  if (!error.response) {
    return Promise.reject(new APIError(ErrorType.CLINENT, null, error.message))
  }
  let errorMessage = error.response && error.response.data ? error.response.data.message : error.message
  let responseStatus = error.response.status
  if (responseStatus === 400) {
    return Promise.reject(new APIError(ErrorType.CLINENT, responseStatus, errorMessage))
  } else if (responseStatus === 401) {
    return Promise.reject(new APIError(ErrorType.UNAUTHORIZED, responseStatus, errorMessage))
  } else if (responseStatus === 403) {
    return Promise.reject(new APIError(ErrorType.NOPERMISSION, responseStatus, errorMessage))
  } else if (responseStatus === 409) {
    if (errorMessage.includes('engine_service:')) {
      errorMessage = errorMessage.split('engine_service:').join('')
    }
    return Promise.reject(new APIError(ErrorType.CUSTOMIZE, responseStatus, errorMessage))
  } else if (responseStatus === 500) {
    return Promise.reject(new APIError(ErrorType.SERVER, responseStatus, errorMessage))
  } else {
    return Promise.reject(new APIError(ErrorType.UNKNOWN, responseStatus, errorMessage))
  }
})

export const baseAPIRequest = function (endPoint, method, params, blob) {
  let config = {
    method: method,
    url: endPoint,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Methods': '*'
    }
  }
  if (blob) {
    config.responseType = 'blob'
  }
  if (['post', 'put', 'patch'].includes(method)) {
    config.data = JSON.stringify(params)
  } else {
    config.params = params || ''
  }
  return axiosInstance.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return dealError(error)
  }).catch(function (error) {
    return dealError(error)
  })
}

export const baseAPIRequestMap = function (endPoint, method, params, blob) {
  let token = store.getters.token
  if (token) {
    endPoint = endPoint + '?token=' + token
  } else {
    store.dispatch('userOAuth', true)
    return Promise.reject(new APIError(ErrorType.UNAUTHORIZED, null, 'token为空'))
  }
  let config = {
    method: method,
    url: endPoint,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Methods': '*'
    }
  }
  if (blob) {
    config.responseType = 'blob'
  }
  if (['post', 'put', 'patch'].includes(method)) {
    config.data = JSON.stringify(params)
  } else {
    config.params = params || ''
  }
  return axiosInstanceMap.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return dealError(error)
  }).catch(function (error) {
    return dealError(error)
  })
}

export const baseAPIRequestCar = function (endPoint, method, params, blob) {
  let config = {
    method: method,
    url: endPoint,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Methods': '*'
    }
  }
  if (blob) {
    config.responseType = 'blob'
  }
  if (['post', 'put', 'patch'].includes(method)) {
    config.data = params
  } else {
    config.params = params || ''
  }
  return axiosInstanceCar.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return dealError(error)
  }).catch(function (error) {
    return dealError(error)
  })
}

const dealError = function (error) {
  if (!error.unprocessed) {
    return Promise.reject(error)
  }
  let showMessage = null
  if (['CLINENT', 'UNKNOWN', 'NETWORK'].includes(error.type)) {
    // 发请求失败，请求结果出异常且为空，未知错误 处理
    showMessage = '请求失败，请检查网络！'
  } else if (['UNAUTHORIZED'].includes(error.type)) {
    // 未认证，即token无效，没有登录 跳转登录页面
    // store.dispatch('clearToken')
    router.push({name: 'auth'})
    showMessage = ''
  } else if (['NOPERMISSION'].includes(error.type)) {
    // 没有权限
    showMessage = '您没有该操作权限，请联系管理员赋权！'
  } else if (['CUSTOMIZE'].includes(error.type)) {
    // 自定义错误，后台捕获的错误
    showMessage = '请求失败:' + error.message
  } else if (['SERVER'].includes(error.type)) {
    // 异常错误
    showMessage = '服务器错误，请联系管理员! 错误信息:' + error.message
  } else {
    showMessage = '未知错误，请联系管理员! 错误信息:' + error.message
  }
  if (showMessage) {
    store.dispatch('showNoticeMsg', {type: 'error', title: '请求失败', message: showMessage})
  }
  error.unprocessed = false
  return Promise.reject(error)
}

export const authAPIRequest = function (endPoint, method, params, blob) {
  let token = store.getters.token
  if (token) {
    endPoint = endPoint + '?token=' + token
    return baseAPIRequest(endPoint, method, params, blob)
  } else {
    store.dispatch('userOAuth', true)
    return Promise.reject(new APIError(ErrorType.UNAUTHORIZED, null, 'token为空'))
  }
}

export const fileAPIRequest = function (endPoint, method, params, noBlob) {
  let token = store.getters.token
  if (token) {
    endPoint = endPoint + '?token=' + token
  }
  let config = {
    method: method,
    url: endPoint,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Access-Control-Allow-Methods': '*'
    }
  }
  if (!noBlob) {
    config.responseType = 'blob'
  }
  config.data = params
  return axiosInstance.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return dealError(error)
  }).catch(function (error) {
    return dealError(error)
  })
}

export const uploadFileAPIRequest = function (endPoint, data, blob) {
  let config = {
    method: httpRequestMethods.POST,
    url: endPoint,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Methods': '*'
    },
    data: data
  }

  if (blob) {
    config.responseType = 'blob'
  }

  return axiosInstanceUpload.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return dealError(error)
  }).catch(function (error) {
    return dealError(error)
  })
}



// WEBPACK FOOTER //
// ./src/cllib/axios_init.js